"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authWatcher = authWatcher;

var _effects = require("redux-saga/effects");

var types = _interopRequireWildcard(require("./types"));

var actions = _interopRequireWildcard(require("./actions"));

var _actions2 = require("../user/actions");

var _Utils = _interopRequireDefault(require("../../utils/Utils"));

var _selectors = require("./selectors");

var _actions3 = require("../apiFlow/authRefresh/actions");

var _config = require("../../config");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(resetStore),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(authWorker),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(tokenExpireCheckerWorker),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(authWatcher);

function resetStore() {
  return regeneratorRuntime.wrap(function resetStore$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _actions2.resetState)());

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function authWorker() {
  return regeneratorRuntime.wrap(function authWorker$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.put)(actions.unauthorize());

        case 2:
          _context2.next = 4;
          return (0, _effects.call)(resetStore);

        case 4:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var tokenExpireTimerID;

function tokenExpireCheckerWorker() {
  var refreshToken, refreshTokenData, refreshTimeout, checkTokenExpireTimeout;
  return regeneratorRuntime.wrap(function tokenExpireCheckerWorker$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          if (tokenExpireTimerID) {
            clearTimeout(tokenExpireTimerID);
          }

          _context3.next = 3;
          return (0, _effects.select)(_selectors.getRefreshToken);

        case 3:
          refreshToken = _context3.sent;

          if (!refreshToken) {
            _context3.next = 22;
            break;
          }

          _context3.prev = 5;
          refreshTokenData = _Utils["default"].parseJwt(refreshToken);
          refreshTimeout = refreshTokenData.exp - Date.now() / 1000;
          console.debug("Session expire after ", refreshTimeout, " sec");

          if (!(refreshTimeout < 0)) {
            _context3.next = 12;
            break;
          }

          _context3.next = 12;
          return (0, _effects.put)((0, _actions3.saga)());

        case 12:
          checkTokenExpireTimeout = _config.Config.get("settings", "checkTokenExpireTimeout"); // Wait 1 min and check again

          _context3.next = 15;
          return (0, _effects.delay)(checkTokenExpireTimeout * 1000);

        case 15:
          _context3.next = 17;
          return (0, _effects.put)((0, actions.tokenTimeoutCheckerSaga)());

        case 17:
          _context3.next = 22;
          break;

        case 19:
          _context3.prev = 19;
          _context3.t0 = _context3["catch"](5);
          console.error(_context3.t0.message);

        case 22:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[5, 19]]);
}

function authWatcher() {
  return regeneratorRuntime.wrap(function authWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.takeEvery)(types.UNAUTHORIZE_SAGA, authWorker);

        case 2:
          _context4.next = 4;
          return (0, _effects.takeEvery)(types.TOKEN_EXPIRE_CHECKER_SAGA, tokenExpireCheckerWorker);

        case 4:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}